import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'zeymo.moduleScope';

/**
 * Narrows this browser tab's sidebar to one module (ZEY-2419). /app/:key sets it for a native module,
 * so a module opened from the launchpad shows only its own menu. Kept in sessionStorage, so it is per
 * tab and survives a reload; other tabs keep the full menu.
 */
@Injectable({ providedIn: 'root' })
export class ModuleScopeService {
  private readonly scopeSubject = new BehaviorSubject<string | null>(ModuleScopeService.read());

  /** Uid of the top-level menu item the sidebar is narrowed to, or null for the full menu. */
  readonly scope$ = this.scopeSubject.asObservable();

  get scope(): string | null {
    return this.scopeSubject.value;
  }

  set(menuUid: string): void {
    try { sessionStorage.setItem(STORAGE_KEY, menuUid); } catch { /* storage blocked: scope lasts until reload */ }
    this.scopeSubject.next(menuUid);
  }

  clear(): void {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
    if (this.scopeSubject.value !== null) this.scopeSubject.next(null);
  }

  private static read(): string | null {
    try { return sessionStorage.getItem(STORAGE_KEY); } catch { return null; }
  }
}
